import React from 'react';

import Button from '../CookingClasses/Button';

const GlobalPopup = ({ isVisible, onClose }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      id="popup-overlay"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        id="cooking-class-hero"
        className="relative w-[90vw] max-w-4xl lg:w-[75vw] lg:max-w-5xl h-auto max-h-[90vh] lg:min-h-[580px] 1024:h-auto bg-[url('../images/cooking_classes_hero.png')] 1024:bg-[#085511]/25 bg-cover bg-center bg-blend-multiply overflow-hidden shadow-2xl rounded-lg flex flex-col justify-center items-center gap-y-10 p-8 sm:p-12 md:p-16 lg:p-20 pb-12 sm:pb-16 md:pb-20 lg:pb-24"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white bg-black bg-opacity-50 rounded-full p-2 z-10 hover:bg-opacity-75"
          aria-label="Close popup"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="w-full flex flex-col justify-center items-center gap-y-6 md:gap-y-8">
          <h1 className="text-white text-center pt-2.5 font-bold font-gelica text-_2832 1024:text-_4050" style={{ textShadow: '0 2px 25px rgba(0,0,0,0.85);' }}>
            Dorot Gardens x Homemade: Cook With Us!
          </h1>
          <h3 className="font-goldplay font-semibold text-white text-center text-_1824 md:text-_2028 lg:text-_2432" style={{ textShadow: '0 2px 15px rgba(0,0,0,0.85);' }}> 
            Fresh Ingredients. Unforgettable Flavors. Free Cooking Classes You'll Love
          </h3>
          <Button
            text={"JOIN THE COOKING CLASS"}
            url={"https://homemadecooking.com/class/easy-breezy-brunch/"}
            type={"hero"}
          />
        </div>
      </div>
    </div>
  );
}

export default GlobalPopup;
